'use client'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'


export const USER_DETAIL_STORE_KEY = 'user-detail-store'

const defaultStore = {
  name: "",
  email: "",
  avatar: "",
  vip: false,
  coin: 0,
  star_coin: 0,
  is_translate: 0,
  lang_code: "",
  gender: 0,
  login_type: "",
  login_time: 0,
  channel_id: 0,
  can_create: 0,
  invite_code: '',
  login_password: '',
  invite_num: 0,
  invite_url: "",
  is_bind_email: true,
  is_set_password: true,
  invitees: false,
  invites: 0,
  author_note: "",
  countdown: 0,
  vip_type: null,
  ad_free: false,
  is_allow_voice: true,
  is_robots_share_link: true,
  user_id: '',
  nsfw: null! as number,
  // 年龄档位 0:<14 1:14-17 2:18-20 3:21-23 4:24-26 5:26+，null 表示未设置
  age: null as number | null,
  is_chat_stream: 0,
  user_log: null as null | {
    vip_expire_time?: number
    marketing_pop_up_day_num?: number
  },
}

const initializer = (set, get) => ({
  ...defaultStore,

  setDetail: (detail) => {
    set({ ...detail })
  },
  setLangCode(val: string) {
    set({ lang_code: val })
  },
  clearDetail: () => set({ ...defaultStore }),
  setVal: (key, val) => set({ [key]: val }),
  subCoin(val: number = 1) {
    set({ coin: get().coin - val })
  },
  addCoin(val: number = 1) {
    set({ coin: get().coin + val })
  },
  subStarCoin(val: number = 1) {
    set({ star_coin: get().star_coin - val })
  },
  addStarCoin(val: number = 1) {
    set({ star_coin: get().star_coin + val })
  }
})

const createUserDetailStore = () => initializer

export const useUserDetailStore = create(persist(createUserDetailStore(), { name: USER_DETAIL_STORE_KEY }))